/* React */
import React from 'react';
import ReactDOM from 'react-dom/client';
/* Routing */
import { Routes, BrowserRouter, Route } from 'react-router-dom';
/* Contexts */
import { AuthProvider } from './context/AuthProvider';
/* Components */
import App from "./App";
/* Style */
import './style/main.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <BrowserRouter>
                <Routes>
                    <Route path="/*" element={ <App /> } />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    </React.StrictMode>
);